export default Object.freeze({
    ENTER: 13,
})
